export default "__VITE_ASSET__BTtVwxnK__"